module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-alert', {
    attrs: {
      "title": _vm.title,
      "type": _vm.type,
      "description": _vm.description,
      "closable": false,
      "show-icon": ""
    }
  }, [_vm._t("description")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8296203e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/EdAlert.vue
// module id = 1522
// module chunks = 45